module.exports = __webpack_public_path__ + "static/img/4a.d0c0f4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/4a.jpg
// module id = EDK4
// module chunks = 0